module.exports = __webpack_public_path__ + "static/media/0.2a4908e5.jpg";